export const DeactivateIcon = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.2513 8C15.2513 12.0017 12.0028 15.25 8.00063 15.25C3.99844 15.25 0.75 12.0017 0.75 8C0.75 3.99827 3.99844 0.75 8.00063 0.75C12.0028 0.75 15.2513 3.99827 15.2513 8Z"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.9991 2.91725L2.91748 12.9996"
				stroke="black"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
